import { useEffect } from "react";

const SITE = "Platform 18";

export function usePageTitle(title?: string) {
  useEffect(() => {
    document.title = title ? `${title} · ${SITE}` : `${SITE} · Find your place in the Detroit Jewish community`;
  }, [title]);
}
